import { useEffect, useState } from 'react';
import axios from 'axios';
import { setGuestActivePassStatus } from '../components/guest-map/GuestMapSurface';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * A guest is "active" when they have at least one guest_pass whose
 * `active_from <= now <= expires_at`. Scheduled-but-not-yet-active
 * passes don't count.
 *
 * The "Get directions" and "Message venue" entry points on the map
 * gate on this. On failure we default to `true` so a flaky network
 * never accidentally locks the guest out of legitimate actions.
 *
 * Also syncs the module-level singleton in GuestMapSurface so the
 * inline card CTAs stay in lockstep.
 */
export function useGuestActivePass() {
  const [hasActivePass, setHasActivePass] = useState(true);
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setHasActivePass(false);
      setGuestActivePassStatus(false);
      return;
    }
    axios
      .get(`${API}/guest-passes/my`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        const now = new Date();
        const passes = Array.isArray(res.data) ? res.data : [];
        const active = passes.some((p) => {
          const af = p.active_from ? new Date(p.active_from) : null;
          const ea = p.expires_at ? new Date(p.expires_at) : null;
          return (!af || af <= now) && (!ea || ea > now);
        });
        setHasActivePass(active);
        setGuestActivePassStatus(active);
      })
      .catch(() => {
        setHasActivePass(true);
        setGuestActivePassStatus(true);
      });
  }, []);
  return hasActivePass;
}
